export default __webpack_public_path__ + "static/media/icon-robot-select.fc1c016f.webp";